(ns storrito.editor.icon-sticker
  (:require [storrito.editor.sticker-design :as sticker-design]
            [storrito.editor.sticker-util :as sticker-util]
            [goog.object :as obj]))

(defn set-background-gradient!
  [^js fabric-element gradient]
  (.set fabric-element
        "fill"
        (js/fabric.Gradient.
          #js{:coords #js{:x1 0
                          :y1 0
                          :x2 fabric-element.width
                          :y2 fabric-element.height}
              :type "linear"
              :gradientUnits "pixels"
              :colorStops (sticker-util/convert-color-stops gradient)})))

(defn icon-sticker
  [{:keys [id design top left angle scaleX scaleY link location text]
    :or {design (first sticker-design/new-link-designs)
         top 10
         left 10
         angle 0
         scaleX 0.8
         scaleY 0.8
         id "link-sticker"}}]
  (let [opacity (:opacity design)
        text (or text
                 (:text link)
                 (:name location)
                 (obj/get location
                          "name")
                 "")
        padding-x (:padding-x design 200)
        padding-y (:padding-y design 0)
        ;; Use Array.from to split by Unicode code points instead of
        ;; UTF-16 code units. Prevents splitting surrogate pairs when
        ;; truncating text that contains emoji. See rich comment below.
        codepoints (js/Array.from text)
        text-length (.-length codepoints)
        sub-text (.toUpperCase
                   (if (> text-length 29)
                     (str (.join (.slice codepoints 0 28) "")
                          "...")
                     text))
        text-props (:text-props design)
        text-object (js/fabric.Text. sub-text
                                     (clj->js (merge
                                                {:fill "#000000"
                                                 :left 50
                                                 :originX "center"
                                                 :originY "center"
                                                 :top 7
                                                 :fontSize 150
                                                 :fontFamily "AvenyT"
                                                 :text-align "center"}
                                                text-props)))
        width (+ text-object.width padding-x)
        height (+ text-object.height padding-y)
        rect-object (js/fabric.Rect.
                      (clj->js
                        {:originX "center"
                         :originY "center"
                         :width width
                         :height height
                         :fill "#ffffff"
                         :opacity opacity
                         :rx (:rx design 30)
                         :ry (:ry design 30)}))

        icon-object (get sticker-design/icon-map
                         (get-in design
                                 [:icon-props :src]))
        icon-props (:icon-props design)
        icon (js/fabric.Image.
               icon-object
               (clj->js (merge {:originX "left"
                                :originY "center"
                                :left (+ (/ width -2)
                                         (:left icon-props 20))
                                :scaleX 0.28
                                :scaleY 0.28}
                               (dissoc icon-props
                                       :left))))]

    (when-let [gradient (:gradient design)]
      (set-background-gradient! text-object
                                gradient))

    (js/fabric.Group. (into-array [rect-object icon text-object])
                      (clj->js
                        (cond->
                            {:id id
                             :text text
                             :lockScalingFlip true
                             :min-scale 0.1
                             :max-scale 5.0
                             :dirty true
                             :top top
                             :left left
                             :link link
                             :angle angle
                             :scaleY scaleY
                             :scaleX scaleX}
                            location
                            (assoc :location (clj->js location))

                            link
                            (assoc :link link))))))

(comment
  
  ;; Bug reproduction for the Array.from fix above.
  ;;
  ;; The text "scopri la nuova collezione 🏔️" is 30 UTF-16 code units
  ;; but only 29 Unicode code points. The mountain emoji 🏔 (U+1F3D4)
  ;; is a supplementary character stored as a surrogate pair (D83C DFD4)
  ;; starting at UTF-16 position 27.
  ;;
  ;; Original bug (count/subs):
  ;;   (count text) → 30 (UTF-16 code units), > 29 → truncates
  ;;   (subs text 0 28) → includes high surrogate D83C at position 27
  ;;     but not low surrogate DFD4 at position 28 → lone surrogate
  ;;   FabricJS graphemeSplit → getWholeChar throws:
  ;;     "High surrogate without following low surrogate"
  ;;
  ;; Fix (Array.from):
  ;;   (.-length (js/Array.from text)) → 29 (code points), ≤ 29 → no truncation
  ;;   Full text with intact surrogate pair passed to fabric.Text → works
  (icon-sticker
    {:text "scopri la nuova collezione 🏔️"
     :link {:text "scopri la nuova collezione 🏔️"
            :url "https://example.com"}
     :scaleX 1
     :scaleY 1
     :top 0
     :left 0
     :design (first sticker-design/new-link-designs)})

  *e
  )
